module.exports = __webpack_public_path__ + "img/img_wait_king.fad14c3b.png";